export default "__VITE_ASSET__CUUklmjk__"